import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { FilterSecondary, FilterSecondaryPropsType } from './FilterSecondary';
import { FilterSecondaryBetBuilderIcon } from './FiltersSecondary.style';

export const FilterSecondaryBetBuilder = ({ isActive, ...rest }: FilterSecondaryPropsType): JSX.Element => {
    return (
        <FilterSecondary
            isActive={isActive}
            filterType='bet-builder'
            {...rest}
        >
            <FilterSecondaryBetBuilderIcon />
            <I18n
                langKey='bet-builder.button.bet-builder'
                defaultText='Bet Builder'
            />
        </FilterSecondary>
    );
};
